/** Placeholder the article body is split on to render the CTA as a component. */
export const CTA_SLOT = '<div data-cta-slot="1"></div>';

/** Where in the article the mid-article module aims to sit, by length. */
export const CTA_TARGET = 0.35;

/**
 * Mark where the single mid-article CTA goes: the section break (an H2 after
 * the first) nearest 35% of the way through the article.
 *
 * It used to be the middle H2 by count, which in long list posts lands 60-66%
 * of the way down. Clarity (Oct 2026) showed about a third of desktop readers
 * get that far on the two most-read posts, against 41-53% at the 35% mark.
 *
 * Short articles get none: the closing module is already within a screen of
 * the last paragraph.
 */
export function insertCtaSlot(html: string): string {
  const h2s = Array.from(html.matchAll(/<h2[^>]*>/gi)).map(m => m.index ?? -1).filter(i => i >= 0);
  if (h2s.length < 4) return html;
  const target = html.length * CTA_TARGET;
  const at = h2s.slice(1).reduce((best, i) => (Math.abs(i - target) < Math.abs(best - target) ? i : best));
  return html.slice(0, at) + CTA_SLOT + html.slice(at);
}

/** Marker for the second module on posts that carry two (see LIST_POST_CTAS). */
export const CTA_SLOT_2 = '<div data-cta-slot="2"></div>';

/**
 * Slots for long list posts, where the 35% mark lands deep inside the list and
 * most readers never get there. The first module goes where the list starts
 * (before the second section); the second goes before the practical
 * "How to..." section near the end, or at the section nearest 75% if there is
 * none. Short posts fall back to the single mid-article slot.
 */
export function insertListCtaSlots(html: string): string {
  const h2s = Array.from(html.matchAll(/<h2[^>]*>(.*?)<\/h2>/gis)).map(m => ({ at: m.index ?? -1, text: m[1].replace(/<[^>]+>/g, "").trim() }));
  if (h2s.length < 4) return insertCtaSlot(html);
  const first = h2s[1].at;
  const howTo = h2s.slice(2).find(h => /^how to\b/i.test(h.text));
  const target = html.length * 0.75;
  const second = howTo
    ? howTo.at
    : h2s.slice(2).reduce((best, h) => (Math.abs(h.at - target) < Math.abs(best.at - target) ? h : best)).at;
  return html.slice(0, first) + CTA_SLOT + html.slice(first, second) + CTA_SLOT_2 + html.slice(second);
}
